import { render } from "./PresentismoArmado.vue?vue&type=template&id=36d6acce&scoped=true"
import script from "./PresentismoArmado.vue?vue&type=script&lang=js"
export * from "./PresentismoArmado.vue?vue&type=script&lang=js"

import "./PresentismoArmado.vue?vue&type=style&index=0&id=36d6acce&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d6acce"]])

export default __exports__